
/**
 * VideoJS Player
 *
 */
function videoJS() {
    let data_setup = {
        fluid: true,
        autoplay: true,
        preload: true,
        controls: true
    }
    let _player = $('#bvp-player')[0];
    let player = videojs(_player, data_setup);

    player.ready(function () {  
        let promise = player.play();
        if (promise !== undefined) {
            promise.then(function (res) {
                console.log('Started', res);
            }, function (error) {
                console.log('error', error);
            });
        }
    });
}

/**
 * Init
 *
 */
function init() {
    videoJS();
}

$(document).ready(init);
